module.exports = __webpack_public_path__ + "media/images/nrf/NRF_1980x400-4ce84fc7133d1d93ae2b4a32fcc82329.jpg";